import { Component, Input, OnInit } from '@angular/core';
import { OnyxSummaryEvent } from '../../models/event.summary';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { Page } from '../../../shared/models/page';
import { Constants } from 'app/shared/constants';

@Component({
  selector: 'pioneer-event-list-default-table',
  templateUrl: './event-list-default-table.component.html'
})
export class EventListDefaultTableComponent implements OnInit {

  @Input()
  events: Page<OnyxSummaryEvent>;

  constructor(private environment: EnvironmentConfiguration) {
  }

  ngOnInit() {
  }

  get eventCount(): number {
    return this.events.totalElements;
  }

  get eventCountForTranslate(): Object {
    return {
      eventCount: this.eventCount
    };
  }

  getEventNameLine1(name: string): string {
    if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
      return name.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
    } else {
      return name;
    }
  }

  getEventNameLine2(name: string): string {
    if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
      const line2: string = name.substring(Constants.EVENTS_NAME_MAX_SIZE);
      if (line2.length > Constants.EVENTS_NAME_MAX_SIZE) {
        return line2.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
      } else {
        return line2;
      }
    } else {
      return null;
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-list/event-list-default-table/event-list-default-table.component.ts